export default class ProductSalesPopUpData {
  ProductId: number;
  ProductName: string;
  ImageUrl: string;
  Customer: string;
  DateSold: string;
  Location: string;
}
